import { type ApiError, type IEntryType, type IRow } from ".";
import * as selectors from "../redux/selectors/guestlist";

export * from "./model";
// export * from "./selectors";
export * from "../redux/reducers/guestlistReducer";

const getGuestlist = (state: any): server.dto.LegacyGuestlist => selectors.getGuestlist(state.guestlist);

const getIsLoading = (state: any): boolean => selectors.getIsLoading(state.guestlist);

const getHasData = (state: any): boolean => selectors.getHasData(state.guestlist);

const getGuestsHasError = (state: any): boolean => selectors.getGuestsHasError(state.guestlist);

const getGuestlistSettingsModalIsShown = (state: any): boolean => selectors.getGuestlistSettingsModalIsShown(state.guestlist);

const getPlaceManagementIsLoading = (state: any): boolean => selectors.getPlaceManagementIsLoading(state.guestlist);

const getAddingModalIsShown = (state: any): boolean => selectors.getAddingModalIsShown(state.guestlist);

const getAddingModalErrors = (state: any): ApiError[] => selectors.getAddingModalErrors(state.guestlist);

const getAddingModalIsLoading = (state: any): boolean => selectors.isGuestAddModalLoading(state.guestlist);

const getAddingGuest = (state: any): server.dto.LegacyGuest => selectors.getAddingGuest(state.guestlist);

const shouldShowPlaceDeleteModal = (state: any): boolean => selectors.shouldShowPlaceDeleteModal(state.guestlist);

const getEntryTypes = (state: any): IEntryType[] => selectors.getEntryTypes(state.guestlist);

const getShowId = (state: any): number => selectors.getShowId(state.guestlist);

const getGuestlistSettingsErrors = (state: any): ApiError[] => selectors.getGuestlistSettingsErrors(state.guestlist);

const getPlaceManagementErrors = (state: any): ApiError[] => selectors.getPlaceManagementErrors(state.guestlist);

const getCurrentEditedRow = (state: any): IRow => selectors.getCurrentEditedRow(state.guestlist);

const getGuestlistSettingsIsLoading = (state: any): boolean => selectors.getGuestlistSettingsIsLoading(state.guestlist);

const getIsSearching = (state: any): boolean => selectors.getIsSearching(state.guestlist);

const getSearchResult = (state: any): server.dto.LegacyGuestlistPlace[] => selectors.getSearchResult(state.guestlist);

const canEditNoGuest = (): boolean => selectors.canEditNoGuest();

const canEditGuestlistSettings = (state: any): boolean => selectors.canEditGuestlistSettings(state.guestlist);

const canEditAllGuests = (state: any): boolean => selectors.canEditAllGuests(state.guestlist);

const canEditOwnGuests = (state: any): boolean => selectors.canEditOwnGuests(state.guestlist);

const isGuestlistDeletionModalShown = (state: any): boolean => selectors.getGuestlistDeletionIsShown(state.guestlist);

const getHasError = (state: any): boolean => selectors.getHasError(state.guestlist);

const getGuestCount = (state: any): number => selectors.getGuestCount(state.guestlist);

export const selector = {
  canEditAllGuests,
  canEditGuestlistSettings,
  canEditNoGuest,
  canEditOwnGuests,
  getAddingGuest,
  getAddingModalErrors,
  getAddingModalIsLoading,
  getAddingModalIsShown,
  getCurrentEditedRow,
  getEntryTypes,
  getGuestlist,
  getGuestlistSettingsErrors,
  getGuestlistSettingsIsLoading,
  getGuestlistSettingsModalIsShown,
  getGuestsHasError,
  getHasData,
  getIsLoading,
  getIsSearching,
  getPlaceManagementErrors,
  getPlaceManagementIsLoading,
  getSearchResult,
  getShowId,
  isGuestlistDeletionModalShown,
  shouldShowPlaceDeleteModal,
  getHasError,
  getGuestCount
};
